export default __webpack_public_path__ + "static/media/upi_logo.6561221e.webp";